// extracted by mini-css-extract-plugin
export var checkbox = "_9s-0";
export var circle = "_9s-3";
export var horizontalContainer = "_9s-7";
export var sm = "_9s-5";
export var switch0 = "_9s-2";
export var switchDisabled = "_9s-8";
export var switchEnabled = "_9s-1";
export var textSwitchContainer = "_9s-9";
export var textSwitchOption = "_9s-a";
export var textSwitchOptionSelected = "_9s-b";
export var verticalContainer = "_9s-6";
export var xs = "_9s-4";